import React from "react";
import { Helmet } from "react-helmet";
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image";

const SEO = ({
  title,
  keywords,
  description,
  pagePath /** ToDo: rename to fullPagePath */,
  image,
  schema = {},
}) => {
  const srcImg = getSrc(image); // Todo check

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>

      <link
        rel="canonical"
        href={pagePath.endsWith("/") ? pagePath : pagePath + "/"}
      />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={srcImg} />
      <meta
        property="og:url"
        content={pagePath.endsWith("/") ? pagePath : pagePath + "/"}
      />
      <meta property="og:type" content="article" />
      <meta property="og:description" content={description} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
export { SEO };
